const Muted = ({ text }) => <span className="uk-text-muted">{text}</span>

export default Muted
